import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { BRAND } from '@/lib/data';
import { Logo } from './Logo';

const LINKS = [
    { href: '#films', label: 'Film' },
    { href: '#process', label: 'How We Shoot' },
    { href: '#about', label: 'About' },
    { href: '#contact', label: 'Contact' },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? 'bg-ink/80 backdrop-blur-xl border-b border-white/5'
                    : 'bg-transparent'
            }`}
        >
            <div className="px-6 md:px-12 lg:px-20 flex items-center justify-between h-20">
                <Logo className="h-9 w-9 text-bone" />

                <nav className="hidden md:flex items-center gap-10">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                            className="text-[11px] uppercase tracking-[0.3em] text-bone-dim hover:text-bone transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#contact"
                    data-testid="nav-cta-book"
                    className="hidden md:inline-block text-[11px] uppercase tracking-[0.3em] border border-white/20 px-5 py-3 text-bone hover:bg-bone hover:text-ink transition-all duration-300"
                >
                    Book a Call
                </a>

                <button
                    data-testid="nav-mobile-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-bone"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-ink/95 backdrop-blur-xl border-t border-white/5">
                    <div className="px-6 py-8 flex flex-col gap-6">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                                className="text-base uppercase tracking-[0.2em] text-bone-dim hover:text-bone"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={BRAND.whatsapp}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="nav-mobile-whatsapp"
                            className="text-sm uppercase tracking-[0.2em] text-gold"
                        >
                            WhatsApp · {BRAND.phone}
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
